import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DefaultList from './default';
import { RoleType } from './types';
import { XTabNav } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const tabList = [
    { id: RoleType.rider, label: '骑士' },
    { id: RoleType.agent, label: '经纪人' },
    { id: RoleType.transport, label: '小运力公司' }
];

const PayManage = (props) => {

    const [curTabID, setCurTabID] = useState(RoleType.rider);

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
        if (props.history.location.curTabID) {
            setCurTabID(props.history.location.curTabID);
        }
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            <DefaultList key={curTabID} curTabID={curTabID}  {...props} />
        </div>
    );
};

PayManage.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,//路由对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(PayManage);